import { FormValues } from '../../types';

export const formatEditRecord = (recordToEdit: any) => {
  const certificateFile = recordToEdit.files.find(
    (file: { type: string }) => file.type === 'certificate',
  );
  const gradeActFile = recordToEdit.files.find(
    (file: { type: string }) => file.type === 'grade_act',
  );

  return {
    academicLevelId: {
      label: recordToEdit.academicLevel,
      value: recordToEdit.academicLevelId,
    },
    country: {
      label: recordToEdit.country,
      value: recordToEdit.countryId,
    },
    institution: {
      label: recordToEdit.institutionCode
        ? `(${recordToEdit.institutionCode}) - ${recordToEdit.institution}`
        : recordToEdit.institution,
      value: recordToEdit.institutionId,
      code: recordToEdit.institutionCode,
      country: recordToEdit.institutionCountry,
    },
    validated: {
      label: recordToEdit.validated ? 'Si' : 'No',
      value: recordToEdit.validated,
    },
    programName: recordToEdit.programName,
    graduationDate: recordToEdit.graduationDate.toString(),
    description: recordToEdit.description,
    institutionId: recordToEdit.institutionId,
    certificate: certificateFile
      ? new File([], `${certificateFile.name}.${certificateFile.extension}`, {
          type: validateFileType(certificateFile.extension),
        })
      : undefined,
    gradeAct: gradeActFile
      ? new File([], `${gradeActFile.name}.${gradeActFile.extension}`, {
          type: validateFileType(gradeActFile.extension),
        })
      : undefined,
  };
};

export const defaultValues = {
  academicLevelId: undefined,
  country: undefined,
  institution: undefined,
  validated: undefined,
  institutionId: undefined,
  programName: undefined,
  graduationDate: undefined,
  description: undefined,
  certificate: undefined,
  gradeAct: undefined,
};

export const submitValues = (data: FormValues, studentId: number) => {
  if (!data.institution?.value) {
    throw new Error('INSTITUION_IS_REQUIRED');
  }
  return {
    programName: data.programName,
    validated: data.validated.value === 'true',
    graduationDate: data.graduationDate,
    academicLevelId: +data.academicLevelId.value,
    countryId: data.country.value as string,
    institutionId: +data.institution.value,
    description: data.description,
    certificate: data.certificate,
    gradeAct: data.gradeAct,
    studentId,
  };
};

const validateFileType = (extension: string) => {
  if (extension === 'pdf') {
    return 'application/pdf';
  }

  if (extension === 'jpg' || extension === 'jpeg') {
    return 'image/jpeg';
  }

  return `image/${extension}`;
};
